export var BngApi = /*#__PURE__*/function () {
  function BngApi(httpClient) {
    this._httpClient = httpClient;
  }

  var _proto = BngApi.prototype;

  _proto.getBusinessNames = function getBusinessNames(businessIdea, tags, industry) {
    return this._httpClient.post('/getBusinessNamesList', {
      businessIdea: businessIdea,
      tags: tags,
      industry: industry
    }).then(function (_ref) {
      var data = _ref.data;
      return data;
    });
  };

  _proto.getDomainsNames = function getDomainsNames(namesList) {
    return this._httpClient.post('/getDomainsList', {
      namesList: namesList
    }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  };

  return BngApi;
}();